import type { Filter } from '../types/data';
import type { FilterModel } from '../types/filters';
import { filterIsValid } from './checks';

/**
 * Convert FilterModel[] (UI model) to Filter[] (API model)
 */
export const convertFilters = (filters: FilterModel[]): Filter[] => {
  return filters
    .filter((f) => f.field !== 'wmg1Labels')
    .filter(filterIsValid)
    .map((f) => ({
      field: f.field,
      op: f.operand!.value as Filter['op'],
      value: f.value as string | string[] | number,
    }));
};
